import React from 'react';
import PropTypes from 'prop-types';
import PopoverMenu from './PopoverMenu/PopoverMenu';
import { getBEMClasses } from 'apex-web/lib/helpers/cssClassesHelper';

import 'apex-web/lib/components/UserSummary/UserSummaryComponent.css';

class UserSummary extends React.Component {
  static propTypes = {
    selectedAccount: PropTypes.shape({
      AccountName: PropTypes.string.isRequired
    }),
    logout: PropTypes.func.isRequired,
    history: PropTypes.object,
    settingsRoute: PropTypes.string,
    activityRoute: PropTypes.string
  };

  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  static defaultProps = {
    settingsRoute: ''
  };

  renderMenuItems = () => {
    const { history, settingsRoute } = this.props;
    const menuItems = [
      { label: this.context.t('Sign Out'), onClick: this.props.logout }
    ];

    if (settingsRoute) {
      menuItems.unshift({
        label: this.context.t('Settings'),
        onClick: () => history.push(settingsRoute)
      });
    }

    menuItems.unshift({
      themeSwitcher: true
    });

    return menuItems;
  };

  updateTheme = () => {
    const { currentTheme } = this.props;
    const storedValues = JSON.parse(localStorage.getItem('apexTemplate')) || {};

    localStorage.setItem(
      'apexTemplate',
      JSON.stringify({
        ...storedValues,
        theme: currentTheme === 'dark' ? 'light' : 'dark'
      })
    );
  };

  render() {
    const { customClass } = this.props;
    const bemClasses = getBEMClasses(['user-summary', customClass]);

    return (
      <div
        className={bemClasses('container')}
        data-account-settings="true">
        <PopoverMenu
          customClass={bemClasses()}
          inline
          inlinePanelAriaLabel={this.context.t('Account settings')}
          items={this.renderMenuItems()}
          updateTheme={this.updateTheme}
          currentTheme={this.props.currentTheme}
        />
      </div>
    );
  }
}

export default UserSummary;
